import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CapacityDeepDiveComponent } from './capacity-deep-dive.component';

const routes: Routes = [
  {
    path: '',
    component: CapacityDeepDiveComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CapacityDeepDiveRoutingModule { }
